import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { DistributorService } from '../../../distributor.service';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { DistributorDetailService } from '../../../distributor-detail.service';
import { UtilitiesService } from '@services/utilities.service';

interface IGenericDeleted {
  title: string;
  deleted_date: number; // epoch ms
}

export interface IListDeletedPE {
  product_exclusive: IGenericDeleted[];
}

@Component({
  selector: 'app-tab-product-exclusive',
  templateUrl: './tab-product-exclusive.component.html',
  styleUrls: ['./tab-product-exclusive.component.scss'],
})
export class TabProductExclusiveComponent implements OnInit, AfterViewInit {
  @ViewChild('modalShowPE') modalShowPE: ModalComponent;
  modalPEConfig = <ModalConfig>{
    modalTitle: 'Produk Ekslusive Dihapus',
    showHeader: false,
    showFooter: false,
    disableCloseButton: () => false,
    onClose: () => this.onModalShowPEClose(),
  };

  @ViewChild('noteWrapper') noteWrapper: ElementRef;

  distributorInfoSubject = new BehaviorSubject<any>({});
  deletedPESubject = new BehaviorSubject({} as IListDeletedPE);
  isLoading = new BehaviorSubject(false);

  constructor(
    private activatedRoute: ActivatedRoute,
    private distributorService: DistributorService,
    private detailDistributorService: DistributorDetailService,
    private utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.setDistributorInfo();
  }

  ngAfterViewInit(): void {}

  setDistributorInfo() {
    const { id, tab, status } = this.activatedRoute.snapshot.params;
    this.distributorInfoSubject.next({
      id_distributor: id,
      status: status,
      tab: tab,
    });
  }

  onModalShowPEOpen() {
    const id = this.activatedRoute.snapshot.params.id;
    this.isLoading.next(true);

    this.detailDistributorService.getDeletedProductExclusive(id).subscribe((resp) => {
      if (!resp) return;
      this.deletedPESubject.next(resp && resp.data);
      this.isLoading.next(false);
    });

    return this.modalShowPE.open();
  }

  onModalShowPEClose() {
    this.noteWrapper.nativeElement.remove();
    return true;
  }

  isSubAreaChanges = () => this.distributorService.DistributorDetailHeader.show_deleted_product_exclusive;

  renderEpochDate(val: number) {
    return this.utils.formatEpochToDate(val);
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
